<div
    class="sticky-premium-navbar"
    [@inOutAnimation]
    [ngStyle]="{ 'height.px': height }"
    *ngIf="isVisible"
>
    <ng-content></ng-content>
</div>
